var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { GET_MFH_ORDER_BOOK, } from "../../interface/orderBook";
var initState = {
    data: {
        ordLst: [],
        isModified: true,
        isCancel: false,
    },
};
var MFOrderBookHoldingsReducer = function (state, action) {
    if (state === void 0) { state = initState; }
    switch (action.type) {
        case GET_MFH_ORDER_BOOK:
            return __assign(__assign({}, state), { data: action.payload.data });
        default:
            return __assign({}, state);
    }
};
export default MFOrderBookHoldingsReducer;
